export default __webpack_public_path__ + "static/media/avatarB1.045c7066.png";